import Typography from "@mui/material/Typography";
import {FormControl, FormControlLabel, LinearProgress, Radio, RadioGroup} from "@mui/material";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import * as React from "react";
import {useState} from "react";
import {getAPI, postAPI} from "../api";
import {Login} from "@mui/icons-material";
import {Information} from "../components/info";


interface LoginRegisterProps {
    close: any;
    storyConf: any[]
    usernameConf: any[]
}

function LoginRegister({close, storyConf, usernameConf}: LoginRegisterProps) {
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [load, setLoad] = useState(false)
    const [radio, setRadio] = useState("Register")
    const [info, setInfo] = useState("")
    const [isRestore, setRestore] = useState(false)
    const [infoStatus, setInfoStatus] = useState(false)
    const [severity, setSeverity] = useState("success")

    const [story, setStory] = storyConf
    const [username, setUsername] = usernameConf

    const get_user_info = () => {
        setPassword("")
        setEmail("")
        getAPI('user/').then(([ok, status, msg]) => {
            setUsername(msg.first_name)
        })
        getAPI("get_store/").then(([ok, status, msg]) => {
            setStory(msg.messages);
        });
        close()
    }

    const verification = () => {
        if (!email || !password) {
            showInfo("Mail and password cannot be empty", "warning")
            setLoad(false)
            return
        }
        postAPI(radio.toLowerCase() + "/", {
            "username": email,
            "password": password,
            "tz": Intl.DateTimeFormat().resolvedOptions().timeZone
        }).then(([ok, status, results]) => {
                if (ok) {
                    get_user_info()
                } else {
                    showInfo(results.error.username, "warning")
                    setLoad(false)

                }
            }
        )
        setLoad(false)
    }

    const restore = () => {
        showInfo("not implemented", "warning")
        // if (!email) {
        //     setInfo("To restore, you need to specify your email")
        //     return
        // }
        // postAPI("restore/", {"email": email}).then(([ok, status, results]) => {
        //     if (ok) {
        //         setInfo("test")
        //         setTimeout(() => {
        //             close()
        //         }, 3000)
        //     } else {
        //         setInfo(results.error)
        //     }
        // });
    }

    const handle = () => {
        setLoad(true)
        if (isRestore) {
            restore()
        } else {
            verification()
        }
    }

    const handle_change = (vl: string) => {
        setRadio(vl)
        setRestore(vl === "Restore")
    }

    const showInfo = (text: string, severity: string) => {
        setInfo(text)
        setSeverity((severity ? severity : ""))
        setInfoStatus(true)
        setTimeout(() => {
            setInfoStatus(false)
        }, 3500)
    }

    return (
        <Box sx={{backgroundColor: "background.paper"}}>
            {infoStatus && (<Information sec={3} text={info} severity={severity}/>)}
            <Typography px={15} py={2}>
                <FormControl>
                    <RadioGroup
                        defaultValue="Register"
                        name="radio-buttons-group"
                        onChange={(event) => handle_change(event.target.value)}
                        color="inherit"
                        aria-haspopup="true"
                    >
                        <FormControlLabel value="Register" control={<Radio/>}
                                          label="register an account."/>
                        <FormControlLabel value="Login" control={<Radio/>}
                                          label="login to account."/>
                        <FormControlLabel value="Restore" control={<Radio/>}
                                          label="restore an account."/>
                    </RadioGroup>
                </FormControl>
            </Typography>
            <Box
                sx={{
                    minWidth: '20dvw',
                    p: 2,
                    backgroundColor: 'background.paper',
                    flexGrow: 1,
                }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        flexGrow: 1,
                    }}>
                    <TextField label="Enter you email" value={email} helperText=" "
                               onChange={(e) => setEmail(e.target.value)}
                    />

                    <TextField label="Your password" type="password" value={password}
                               helperText={isRestore ? "No password required for restore" : " "}
                               disabled={isRestore}
                               onChange={(e) => setPassword(e.target.value)}
                    />

                    <Button onClick={handle}>
                        {radio}
                        <Login/>
                    </Button>
                </Box>
                {load && (<LinearProgress/>)}
            </Box>
        </Box>
    )
}

export default LoginRegister